export const SHOW_MODAL = 'dynamic-list/modal/SHOW_MODAL'
export const HIDE_MODAL = 'dynamic-list/modal/HIDE_MODAL'

export const CLOSE_MODAL = 'dynamic-list/modal/CLOSE_MODAL'
export const SUBMIT_MODAL = 'dynamic-list/modal/SUBMIT_MODAL'



// WEBPACK FOOTER //
// ./src/dynamic-list/redux/modules/modal/types.js